import { View } from '../components/Themed';

export default function PNO() {
  return (
    <View style={{ flex: 1, height: '100%' }}>
      <iframe src="https://bookbumo.lpages.co/pno/" style={{ flex: 1 }} />
    </View>
  );
}
